import { Snackbar, Step, StepLabel, Stepper } from "@mui/material";
import axios from "axios";
import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../component/Header";
import { PriceModel } from "../../model/PriceModel";
import { ReactComponent as Check } from "../../rsc/check.svg";
import { ReactComponent as PempemLogo } from "../../rsc/pempem_logo.svg";
import { LoadingPricePage } from "../LoadingPricePage";
import { Param } from "../MainPage";
import "./CardSelection.scss";
import { StepAskTransport } from "./StepAskTransport";
import { StepChooseMill } from "./StepChooseMill";
import { StepChoosePickup } from "./StepChoosePickup";
import { StepPriceReceived } from "./StepPriceReceived";
import { colorPrimaryDark } from "../../rsc/colors";
import { Footer } from "../../component/Footer";

export function MainPageV2() {

    const [param] = useSearchParams()

    const initParam = useRef<any>(param)

    const [activeStep, setActiveStep] = React.useState(0);

    const [error, setError] = useState<string | undefined>(undefined)

    const needTransport = useRef<boolean | undefined>(undefined)

    const winningPrice = useRef<PriceModel | undefined>(undefined)

    const navigate = useNavigate();

    const [loadingPrice, setLoadingPrice] = useState(false)

    const location = useLocation()

    useEffect(() => {
        // This will run whenever the path changes
        const pathName = location.pathname.split('/')?.at(2)
        if (pathName) {
            if (pathName === 'landingpage2_ask_transport') {
                setActiveStep(0)
            } else if (pathName === 'landingpage2_mill_prices_map' || pathName === 'landingpage2_pickup') {
                setActiveStep(1)
            } else if (pathName === 'landingpage2_price_farm_received') {
                setActiveStep(2)
            }
        }
    }, [location]);

    function fetchNafPrice(pos: any) {
        setLoadingPrice(true)
        axios.get(`${process.env.REACT_APP_BASE_URL_PUBLIC}/mapTilingService/bidByPos/${pos.lng}/${pos.lat}`, {
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((data: any) => {
            const p = data.data.price
            if (p) {
                winningPrice.current = (new PriceModel(0, p))
            } else {
                winningPrice.current = (new PriceModel(-1, -1))
            }
            goToPage('landingpage2_price_farm_received')
        }).catch(e => {
            if (e?.message) {
                setError(e?.message)
            } else {
                setError('An error occured')
            }
        })
            .finally(() => {
                setLoadingPrice(false)
            })
    }

    const steps = [t('landing2_step_1_title'), t('landing2_step_2_title'), t('landing2_step_3_title')];

    const handleNext = () => {
        if (activeStep === 0) {
            if (needTransport.current === true) {
                goToPage("landingpage2_pickup")
            } else {
                goToPage("landingpage2_mill_prices_map")
            }
        } else if (activeStep === 1) {
            goToPage("landingpage2_price_farm_received")
        }
    };

    function goToPage(step: string, extraParam?: Param[]) {
        var newParam: string = ''
        initParam.current.forEach((value: string, key: string) => {
            if (newParam.length > 0) {
                newParam += '&'
            }
            newParam += `${key}=${value}`
        })
        extraParam?.forEach((p: Param) => {
            if (newParam.length > 0) {
                newParam += '&'
            }
            newParam += `${p.key}=${p.value}`
        })
        if (newParam) {
            newParam = '?' + newParam
        }
        // updateInstruction(step)
        if (newParam.length > 0) {
            navigate(`${step}${newParam}`);
        } else {
            navigate(`${step}`);
        }
    }

    const setNeedTransport = (value: boolean) => {
        needTransport.current = value
        handleNext()
    }

    return (
        <div style={{ width: "100%", height:"100%" }}>
            <div style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}>
                <Header />
                <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginTop: "10px", fontWeight: "700", padding: "10px 20px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <Check />
                        <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8" }}>{t('transport_included')}</p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <Check />
                        <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8" }}>{t('no_grading_at_farm')}</p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <Check />
                        <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8" }}>{t('digital_scale')}</p>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center", margin: "10px", alignItems:"center" }}>
                    <p className="text-huge" style={{ fontWeight: "800", color: colorPrimaryDark }}>{t('sell_my_fruit')} {t('to')}</p>
                    <PempemLogo style={{width:'140px', height:"42px"}} fill={colorPrimaryDark} />
                </div>
                <Stepper activeStep={activeStep} style={{ padding: "20px 0" }}>
                    {steps.map((label, index) => {
                        const stepProps: { completed?: boolean } = {};
                        const labelProps: {
                            optional?: React.ReactNode;
                        } = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <React.Fragment>
                    <div style={{ width: "100%", flex:1, display: "flex", flexDirection: "column" }}>
                        <Routes>
                            <Route path="landingpage2_ask_transport" element={
                                <StepAskTransport page="landingpage2_ask_transport" setNeedTransport={setNeedTransport} />
                            } />
                            <Route path="landingpage2_mill_prices_map/*" element={
                                activeStep === 1 &&
                                <StepChooseMill page="landingpage2_mill_prices_map" onPriceAccepted={(p: PriceModel) => { winningPrice.current = p; handleNext() }} />
                            } />
                            <Route path="landingpage2_pickup" element={
                                activeStep === 1 &&
                                <StepChoosePickup page="landingpage2_pickup" onPickupSelected={(coord: number[]) => fetchNafPrice(coord)} />
                            } />
                            <Route path="landingpage2_price_farm_received" element={
                                <StepPriceReceived needTransport={needTransport.current} winningPrice={winningPrice.current} page="landingpage2_price_farm_received" />
                            } />
                        </Routes>
                    </div>
                </React.Fragment>
                {
                    loadingPrice &&
                    <div style={{ position: "absolute", top: '60px', bottom: 0, left: 0, right: 0, zIndex: "9", backgroundColor: "#fff", display: "flex", justifyContent: "center" }}>
                        <LoadingPricePage />
                    </div>
                }
                {
                    error ?
                        <Snackbar
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "center"
                            }}
                            open={error !== undefined}
                            autoHideDuration={6000}
                            onClose={() => { setError(undefined) }}
                            message={error}
                            sx={{
                                '& .MuiSnackbarContent-root': {
                                    backgroundColor: "#f00",
                                    fontWeight: "600"
                                }
                            }}
                        /> : <></>
                }
            </div>
            <Footer/>
        </div>
    )
}